import axios from 'axios';

export const mapsList = () => { return axios.get("/customer/page") };
export const mapsSave = (params) => {
    // 将 params 对象转换为 JSON 字符串
    const jsonData = JSON.stringify(params);

    // 发送 POST 请求的 URL
    const url = "/customer/savePage";

    // 发送 POST 请求
    return axios.post(url, jsonData, {
        headers: {
            'Content-Type': 'application/json' // 告诉服务器发送的是 JSON 数据
        }
    })
};


// WEBPACK FOOTER //
// ./src/api/mapsMG.js